import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import StopIcon from '@material-ui/icons/Stop';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';
import CheckBox from 'components/form/Radio';
import Divider from './CustomDivider';
import { Radio } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary['50'],
    maxWidth: 620,
    // margin: 'auto',
    padding: theme.spacing(3),
  },
  iconButton: {
    backgroundColor: 'white',
    maxWidth: 48,
    minWidth: 48,
    maxHeight: 48,
    minHeight: 48,
  },
  iconButtonFilled: {
    '&:not(:disabled)': {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    'maxWidth': 48,
    'minWidth': 48,
    'maxHeight': 48,
    'minHeight': 48,
  },
  radio: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

const CONTRACT_URL = `https://weadmit-static.s3.us-east-2.amazonaws.com/contracts/`;

const Contract = ({ product, values, setValues, onNext }) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Box marginBottom={3}>
        <Divider />
      </Box>
      <Box display="flex" alignItems="end">
        {/* <DescriptionOutlinedIcon
          fontSize="large"
          color="primary"
          style={{ marginRight: 8 }}
        /> */}
        <Typography variant="h3">{`${product.package_name} Contract`}</Typography>
      </Box>
      <Box marginTop={3} marginBottom={3}>
        <Typography variant="body2">
          Please agree to the "{product.package_name} Contract" and complete
          your personal information.
        </Typography>
      </Box>
      <Box marginBottom={6} display="flex" alignItems="center">
        <Typography style={{ marginRight: 16 }}>Download contract</Typography>
        <Button
          color="primary"
          size="large"
          variant="outlined"
          component="a"
          href={`${CONTRACT_URL}${product.contract_filename}`}
          className={classes.iconButton}
          target="_blank"
        >
          <ArrowDownwardIcon />
        </Button>
      </Box>
      <Box marginBottom={4} display="flex" alignItems="center">
        <Box>
          <Radio
            className={classes.radio}
            disableRipple={true}
            size="small"
            color={'primary'}
            name="selected"
            checked={values.tos}
            onChange={(e) => setValues({ ...values, tos: e.target.checked })}
          />
        </Box>
        <Typography
          component="div"
          variant="caption"
          style={{ fontSize: 14 }}
        >
          {product.product_type === 'solo' || product.product_type === 'cohort'
            ? `I have read and agree to the ${product.package_name} Contract.`
            : `I confirm that I am the student’s parent or legal guardian, and I have read and agree to the ${product.package_name} Contract.`}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center">
        <Typography style={{ marginRight: 16 }}>Agree</Typography>
        <Button
          onClick={onNext}
          color="primary"
          size="large"
          variant="outlined"
          className={classes.iconButtonFilled}
          disabled={!values.tos}
        >
          <ArrowForwardOutlinedIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default Contract;
